import React from 'react';

export const ViewMoreRewardIcon = () => {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="#502314">
      <g>
        <path d="M12 4L10.59 5.41L16.17 11H4V13H16.17L10.59 18.59L12 20L20 12L12 4Z" />
      </g>
    </svg>
  );
};
